
export const analyticsSelector = state => state.analytics;
